import React, { useEffect, useState } from 'react';
import { getCurrentUserAttributes } from '../../sso/components/oauth/auth-provider-methods';
import { hasValue, safeParseJSON, stringToArray } from '../../../general/js/general-helpers';
import { addQueryParams } from '../../../general/js/utils';

export function IMGAMatchupsGameLayout(props) {
    const {
        allowedUserAttributes,
        iFrameDatasource,
        tokenHeader,
        tokenQueryKey
    } = props;

    const [userIdTokenShortened, setUserIdTokenShortened] = useState(undefined);

    useEffect(() => {
        const jwtUtilsPromise = import(
            /* webpackChunkName: "jwt-utils" */
            '../../../general/js/utils/jwt-utils'
        );

        const loadToken = async () => {
            try {
                const [jwtUtils, user] = await Promise.all([
                    jwtUtilsPromise,
                    getCurrentUserAttributes()
                ]);
                const shortenedToken = await jwtUtils.stripToken(
                    user.idToken,
                    stringToArray(allowedUserAttributes),
                    '',
                    safeParseJSON(tokenHeader)
                );
                setUserIdTokenShortened(shortenedToken);
            } catch (e) {
                console.error(e);
            }
        };

        loadToken();
    }, []);

    if (
        !hasValue(userIdTokenShortened) ||
        !hasValue(iFrameDatasource) ||
        !hasValue(iFrameDatasource.source)) {
        return null;
    }

    const iFrameSrc = addQueryParams(iFrameDatasource.source, [
        {
            key: tokenQueryKey,
            value: userIdTokenShortened
        }
    ]);

    return (
        <iframe src={iFrameSrc}></iframe>
    );
}
